module.exports = __webpack_public_path__ + "static/media/choithramsTryNewCuisines.cb45800f.png";